function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.5 23.026H78.5C79.3008 23.026 80 22.3268 80 21.526C80 20.9244 79.6015 20.4244 79.1015 20.1276L45.8005 0.225585C45.3005 -0.075195 44.6989 -0.075195 44.3005 0.225585L10.8005 20.2256C10.199 20.5264 9.9021 21.2256 10.1013 21.9248C10.199 22.5263 10.8005 23.0264 11.4997 23.0264L11.5 23.026ZM45 3.22499L73.102 20.026H16.899L45 3.22499Z",
  fill: "#E2E2E2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M73.5 26.526V64.526C73.5 65.3268 74.1992 66.026 75 66.026C75.8008 66.026 76.5 65.3268 76.5 64.526V26.526C76.5 25.7252 75.8008 25.026 75 25.026C74.1992 25.026 73.5 25.7252 73.5 26.526Z",
  fill: "#E2E2E2"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.5 71.026H78.5C79.3008 71.026 80 70.3268 80 69.526C80 68.7252 79.3008 68.026 78.5 68.026H11.5C10.6992 68.026 10 68.7252 10 69.526C10 70.3268 10.6992 71.026 11.5 71.026Z",
  fill: "#E2E2E2"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.5 76.026H83.5C84.3008 76.026 85 75.3268 85 74.526C85 73.7252 84.3008 73.026 83.5 73.026H6.5C5.69922 73.026 5 73.7252 5 74.526C5 75.3268 5.69922 76.026 6.5 76.026Z",
  fill: "#E2E2E2"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M88.5 78.026H1.5C0.69922 78.026 0 78.7252 0 79.526C0 80.3268 0.69922 81.026 1.5 81.026H88.5C89.3008 81.026 90 80.3268 90 79.526C90 78.7252 89.3008 78.026 88.5 78.026Z",
  fill: "#E2E2E2"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M70.3009 37.327C70.6017 37.1278 70.9025 36.827 71.0002 36.4286C71.1017 36.0301 71.0002 35.6278 70.8009 35.327L66.8009 28.4286C66.6994 28.327 66.6017 28.1278 66.5002 28.0301V26.5262C66.5002 25.7255 65.8009 25.0262 65.0002 25.0262C64.1994 25.0262 63.5002 25.7255 63.5002 26.5262V28.5262L61.3986 29.7254L56.5002 32.5262V26.5262C56.5002 25.7255 55.8009 25.0262 55.0002 25.0262C54.1994 25.0262 53.5002 25.7255 53.5002 26.5262V34.2254L46.5002 38.2254V26.5264C46.5002 25.7257 45.8009 25.0264 45.0002 25.0264C44.1994 25.0264 43.5002 25.7257 43.5002 26.5264V38.3274L36.5002 34.3274V26.5266C36.5002 25.7259 35.8009 25.0266 35.0002 25.0266C34.1994 25.0266 33.5002 25.7259 33.5002 26.5266V32.5266L26.5002 28.5266V26.5266C26.5002 25.7259 25.8009 25.0266 25.0002 25.0266C24.1994 25.0266 23.5002 25.7259 23.5002 26.5266V27.925C23.3986 28.0266 23.3009 28.1243 23.1994 28.3235L19.1994 35.2219C19.0002 35.5227 18.8986 36.0227 19.0978 36.3235C19.297 36.6243 19.4963 37.0227 19.797 37.2219L23.5978 39.4211V51.5231L19.797 53.7223C19.4963 53.9215 19.1955 54.2223 19.0978 54.6208C18.9963 55.0192 19.0978 55.4215 19.1994 55.7224L23.1994 62.6208C23.3009 62.7223 23.3986 62.9215 23.5002 63.0192V64.527C23.5002 65.3278 24.1994 66.027 25.0002 66.027C25.8009 66.027 26.5002 65.3278 26.5002 64.527V62.527L28.6018 61.3278L33.5002 58.527V64.527C33.5002 65.3278 34.1994 66.027 35.0002 66.027C35.8009 66.027 36.5002 65.3278 36.5002 64.527V56.8278L43.5002 52.8278V64.5268C43.5002 65.3276 44.1994 66.0268 45.0002 66.0268C45.8009 66.0268 46.5002 65.3276 46.5002 64.5268V52.7258L53.5002 56.7258V64.5266C53.5002 65.3274 54.1994 66.0266 55.0002 66.0266C55.8009 66.0266 56.5002 65.3274 56.5002 64.5266V58.5266L63.5002 62.5266V64.5266C63.5002 65.3274 64.1994 66.0266 65.0002 66.0266C65.8009 66.0266 66.5002 65.3274 66.5002 64.5266V63.1282C66.6017 63.0266 66.6994 62.929 66.8009 62.7298L70.8009 55.8314C71.0002 55.5306 71.1017 55.0306 71.0002 54.7298C70.8986 54.3313 70.6017 54.0305 70.3009 53.8313L66.5001 51.6321V39.4251L70.3009 37.327ZM63.5001 41.2254V49.9246L56.5001 45.9246V45.3231L63.5001 41.2254ZM26.5001 49.827V41.1278L33.5001 45.1278V45.7294L26.5001 49.827ZM22.5001 35.425L25.0001 31.1242L42.0001 40.925L37.0001 43.8234L22.5001 35.425ZM22.5001 55.628L40.0001 45.526L45.0001 42.6276L65.0001 31.1276L67.5001 35.4284L25.0001 59.9244L22.5001 55.628ZM67.5001 55.628L65.0001 59.9249L48.0001 50.1241L53.0001 47.2257L67.5001 55.628Z",
  fill: "#E2E2E2"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5 26.526V64.526C13.5 65.3268 14.1992 66.026 15 66.026C15.8008 66.026 16.5 65.3268 16.5 64.526V26.526C16.5 25.7252 15.8008 25.026 15 25.026C14.1992 25.026 13.5 25.7252 13.5 26.526Z",
  fill: "#E2E2E2"
});

var SvgClosedLocationIcon = function SvgClosedLocationIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 90,
    height: 82,
    viewBox: "0 0 90 82",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClosedLocationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closed-location-icon.345e321f.svg";
export { ForwardRef as ReactComponent };